<div class="collection-list">
  <lp-collection-list-header
    [title]="'components.lpCollectionList.labels.collectionList' | translate"
    (add)="startCreate.emit()"
  ></lp-collection-list-header>

  <tui-scrollbar>
    <div class="collection-list__content">
      <lp-collection-item
        *ngFor="let item of collections"
        [item]="item"
        (click)="onSelectCollection.emit(item.id)"
      ></lp-collection-item>
    </div>
  </tui-scrollbar>
</div>
